<div class="header">
  <div class="title">
    Time Series Value <span *ngIf="data.model"> : {{ data.model.field_label }}</span>
  </div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="addTimeSeriesChartForm">
  <ng-container *ngIf="!data.model">
    <select-field
      class="flex flex-col select-field"
      [data]="data"
      labelField="Select a Field *"
      [fieldDef]="{
        name: 'field_name',
        label: 'Select a Field',
      }"
      (update)="onFieldSelection($event)"
      [options]="selectFieldOptions()"
      [emptyModel]="!data?.model"
      [rowIndex]="0"
      [colIndex]="0"
    >
    </select-field>
  </ng-container>

  <mat-form-field class="flex-auto gt-xs:pr-3">
    <mat-label>Date</mat-label>
    <input matInput [matDatepicker]="datePicker" [formControlName]="'date'" [placeholder]="'Date'" />
    <mat-datepicker-toggle matSuffix [for]="datePicker"> </mat-datepicker-toggle>
    <mat-datepicker #datePicker></mat-datepicker>
  </mat-form-field>

  <div class="flex flex-col gt-xs:flex-row mt-3" *ngIf="!isCurrencyField">
    <mat-form-field class="flex-auto">
      <mat-label>Value</mat-label>
      <input matInput [formControlName]="'val'" />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row mt-3" *ngIf="isCurrencyField">
    <mat-form-field class="flex-auto">
      <mat-label>Value</mat-label>
      <input matInput [formControlName]="'val'" currencyMask [options]="currencyMaskOptions" />
    </mat-form-field>
  </div>

  <div class="actions">
    <div>
      <button mat-menu-item (click)="deleteTimeSeriesValue()">
        <mat-icon [svgIcon]="'delete'"></mat-icon>
      </button>
    </div>
    <div class="justify-end">
      <div class="buttons">
        <button class="discard-button" mat-button (click)="discard()" type="button">
          <span>Cancel</span>
        </button>
        <button
          class="send-button"
          mat-flat-button
          type="submit"
          [color]="'primary'"
          [disabled]="addTimeSeriesChartForm.pristine || addTimeSeriesChartForm.invalid"
          (click)="save()"
        >
          <span>Save</span>
        </button>
      </div>
    </div>
  </div>
</form>
